import WaitlistForm from "../components/WaitlistForm";
import LaunchNote from "../components/LaunchNote";
import { CHARLIE } from "../lib/api";
import { Instagram } from "lucide-react";

export default function Waitlist() {
  return (
    <>
      <section className="pt-32 md:pt-40 pb-12 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <div className="mono text-[11px] tracking-[0.28em] uppercase text-[#4A7C7B] mb-4">Join the waitlist</div>
            <h1 className="serif text-[clamp(3rem,7vw,6.5rem)] leading-[0.98] tracking-tight text-espresso">
              Save a place for <span className="italic text-[#4A7C7B]">Book One.</span>
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-charcoal/90">
              Join a small, quiet list of parents, teachers, and counselors who want kinder language for the tender chapters. As Book One approaches, you'll receive Charlie's welcome, the free educator's and clinician's guides ahead of launch, and one careful note the day the book arrives.
            </p>
            <div className="mt-12">
              <WaitlistForm source="waitlist-page" />
            </div>

            <div className="mt-10 pt-6 border-t border-black/10">
              <div className="mono text-[10px] tracking-[0.28em] uppercase text-charcoal/70 mb-2">Following along?</div>
              <a
                href="https://www.instagram.com/lovewellproject"
                target="_blank" rel="noreferrer"
                data-testid="follow-instagram"
                className="inline-flex items-center gap-2 text-sm text-espresso hover:text-[#4A7C7B] transition-colors link-draw"
              >
                <Instagram size={16} /> Follow along on Instagram @lovewellproject
              </a>
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="relative">
              <div className="absolute -inset-8 spotlight rounded-[42%_58%_46%_54%/56%_44%_58%_42%]" aria-hidden />
              <img
                src={CHARLIE.teal}
                alt="Charlie the owl"
                className="relative w-full max-w-[520px] mx-auto rounded-[38%_62%_44%_56%/54%_46%_54%_46%]"
              />
            </div>
            <div className="italic-serif text-xs text-charcoal/55 mt-4 text-center">
              Illustrations by Zuzana Svobodová
            </div>
          </div>
        </div>
      </section>

      <LaunchNote />
    </>
  );
}
